/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { empty, errorResponse, isArray, isObject, isString, prepareResponseData } from "../../Utilities/utils";
import { Toast } from "primereact/toast";
import * as Yup from "yup";

// css
import "../students/Students.css";

// api
import bankAccountApi from "../../api/BankAccount";

// components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import FullPageLoader from "../../components/loader/FullPageLoader";
import Header4 from "../../components/headers/Header4";
import colors from "../../config/colors";

// data
import { FaPlus, FaTimesCircle } from "react-icons/fa";
import InputFieldChange from "../../components/form/InputFieldChange";
import PaymentWrapper from "../../components/appWrapper/PaymentWrapper";
import { AuthContext } from "../Root/ProtectedRoute";
import InputField from "../../components/form/InputField";

const validationSchema = Yup.object().shape({
  name: Yup.string().optional(),
  account_name: Yup.string().optional(),
  account_number: Yup.string().optional(),
});

const AddUpdateBankAccount = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const { bankAccountId } = useParams();
  const toastTR = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [bankAccounts, setBankAccounts] = useState([{ id: 1, name: "", account_name: "", account_number: "" }]);
  const [bankAccountDetails, setBankAccountDetails] = useState([]);
  const [initialValues, setInitialValues] = useState({
                                                        name: '',
                                                        account_name: '', 
                                                        account_number: ''
                                                      });

  // alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  useEffect(() => {
    if (bankAccountId) {
      getBankAccountDetails();
    }
  }, [bankAccountId]);

  useEffect(() => {
  }, [bankAccountDetails]);

  /**
   * Get bank account details
   * @returns 
   */
  const getBankAccountDetails = async () => {
    setIsLoading(true);
    try {
      const bankAccounts = isArray(user?.bankAccounts) ? user?.bankAccounts : [];
      let bankAccount = {}; 
      bankAccounts.forEach((account) => {
        if (account?.id === bankAccountId) {
          return bankAccount = account;
        }
      })

      return setInitialValues({
        name: bankAccount?.name || '',
        account_name: bankAccount?.accountName || '', 
        account_number: bankAccount?.accountNumber || ''
      }); 
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Handle submission
   * @param values
   */
  const handleSubmit = async (values) => {
    if (!isLoading) setIsLoading(true);
    try {
      let response;
      let itemAdded = false;
      let itemUpdated = false;

      // validate paylaod
      let isAnyFieldEmpty = false;
      if (isArray(bankAccountDetails)) {
        bankAccountDetails.forEach((bankAccountDetail, index) => {
          if (isObject(bankAccountDetail)) {
            if (empty(bankAccountDetail?.name)) {
              bankAccountDetails[index].isEmpty = true;
              isAnyFieldEmpty = true;
            }
            if (empty(bankAccountDetail?.account_number)) {
              bankAccountDetails[index].isEmpty = true;
              isAnyFieldEmpty = true;
            }
            if (empty(bankAccountDetail?.account_name)) {
              bankAccountDetails[index].isEmpty = true;
              isAnyFieldEmpty = true;
            }
  
            if (isAnyFieldEmpty) {
              setBankAccountDetails(prev => [...bankAccountDetails])
            }
          } else {
            isAnyFieldEmpty = true;
          }
        })
        if (isAnyFieldEmpty) {
          return;
        }
        const payload = {
          bankAccountDetails
        }
        if (!bankAccountId) {
          response = await bankAccountApi.addBankAccount(payload);
          itemAdded = true;
        } else {
          if (empty(values) || !isObject(values)) {
            return responseDialog("error", "Error Alert", "Please enter account details or refresh page if error persists.");
          }
          const updatePayload = {
            name: values?.name || '',
            account_name: values?.account_name || '',
            account_number: values?.account_number || ''
          };
          response = await bankAccountApi.updateBankAccount(
            bankAccountId,
            updatePayload
          );
          itemUpdated = true;
        }
        const response_data = prepareResponseData(response);
        if (!response_data?.success) {
          return responseDialog(
            "error",
            "Error Alert",
            isString(response_data?.response)
              ? response_data.response
              : "Something went wrong!"
          );
        }
  
        navigate("/finance/bank-accounts", {
          state: { itemAdded, itemUpdated },
        });
      }

      responseDialog("error", "Error Alert", "Please enter account details.");
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Handle input type for bank account fields
   */
  const handleInputType = (name, setFieldValue, index, field) => (e) => {
    try {
      const value = e?.target?.value || "";
      
      setBankAccountDetails((prevBankAccounts) => {
        // Ensure prevBankAccounts is an array
        const newBankAccounts = Array.isArray(prevBankAccounts) ? [...prevBankAccounts] : new Array(bankAccounts.length).fill({});
        
        // Ensure the index exists in newBankAccounts
        if (!newBankAccounts[index]) {
          newBankAccounts[index] = {};
        }
  
        // Update the specific field
        if (field === 'name') {
          newBankAccounts[index] = { ...newBankAccounts[index], name: value, isNameEmpty: !empty(value) ? false : true };
        } else if (field === 'account_number') {
          newBankAccounts[index] = { ...newBankAccounts[index], account_number: value, isAccountNumberEmpty: !empty(value) ? false : true };
        } else if (field === 'account_name') {
          newBankAccounts[index] = { ...newBankAccounts[index], account_name: value, isAccountNameEmpty: !empty(value) ? false : true };
        }
        
        return newBankAccounts;
      });
  
      // Update Formik values
      setFieldValue(name, value);
    } catch (error) {
      
    }
  };

    /**
   * Add a new bank account
   */
  const addBankAccount = () => {
    try {
      const newId = bankAccounts.length + 1;
      setBankAccounts((prev) => [...prev, { id: newId }]);
      setBankAccountDetails((prev) => [...(Array.isArray(prev) ? prev : []), {}]);
    } catch (error) {}
  };

  /**
   * Remove a bank account
   */
  const removeBankAccount = (id) => {
    try {
      if (bankAccounts.length > 1) {
        const index = bankAccounts.findIndex((entry) => entry.id === id);
        setBankAccounts((prev) => prev.filter((entry) => entry.id !== id));
        setBankAccountDetails((prev) => {
          const newBankAccounts = Array.isArray(prev) ? [...prev] : [];
          newBankAccounts.splice(index, 1);
          return newBankAccounts;
        });
      }
    } catch (error) {}
  };

  return (
    <>
      <PaymentWrapper {...props}>
        <main>
          <div className="container flex-center-top">
            <MainHeader
              title={
                !empty(bankAccountId)
                  ? "Update Bank Account"
                  : "Add Bank Account"
              }
            />
            <div className="form-container mt-30">
              <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
              {({ setFieldValue }) => (
                <Form style={{ width: "100%" }}>
                  <Header4 children="Bank Account(s)" />
                  { empty(bankAccountId) ?
                    <>
                      <div 
                        className={`flex flex-start col-g-8 pointer`}
                        style={{ color: colors.primary }}
                        onClick={bankAccounts.length < 5 ? addBankAccount : undefined}
                      >
                        <span>Add Bank Account</span>
                        <FaPlus style={{ marginTop: 2 }} />
                      </div>
                      {/* Dynamically render account details */}
                      
                      <div style={{ border: `2px dotted ${colors.primary}`, paddingLeft: 15, paddingRight: 15, paddingBottom: 20, marginTop: 20 }}>
                        {bankAccounts.map((bankAccount, index) => (
                          <div key={bankAccount.id} className="fee-entry">
                            <div className="app_input_group">
                              <InputFieldChange
                                labelTitle="Bank Name"
                                required={true}
                                placeholder="Select Bank Name"
                                name={`bankAccountDetails[${index}].name`}
                                height={50}
                                containerWidth="30%"
                                isDefaultError={false}
                                isError={bankAccountDetails[index]?.isNameEmpty || false}
                                errorMessage={bankAccountDetails[index]?.isNameEmpty ? "This field is required" : null }
                                onChange={handleInputType(
                                  `bankAccountDetails[${index}].name`,
                                  setFieldValue,
                                  index, 
                                  'name'
                                )}
                              />
                              <InputFieldChange
                                placeholder="Enter Bank Account Number"
                                name={`bankAccountDetails[${index}].account_number`}
                                height={50}
                                type="number"
                                labelTitle="Bank Account Number"
                                required={true}
                                containerWidth="30%"
                                isDefaultError={false}
                                isError={bankAccountDetails[index]?.isAccountNumberEmpty || false}
                                errorMessage={bankAccountDetails[index]?.isAccountNumberEmpty ? "This field is required" : null }
                                onChange={handleInputType(
                                  `bankAccountDetails[${index}].account_number`,
                                  setFieldValue,
                                  index,
                                  "account_number"
                                )}
                              />
                              <InputFieldChange
                                labelTitle="Bank Account Name"
                                required={true}
                                placeholder="Select Bank Account Name"
                                name={`bankAccountDetails[${index}].account_name`}
                                height={50}
                                containerWidth="30%"
                                isDefaultError={false}
                                isError={bankAccountDetails[index]?.isAccountNameEmpty || false}
                                errorMessage={bankAccountDetails[index]?.isAccountNameEmpty ? "This field is required" : null }
                                onChange={handleInputType(
                                  `bankAccountDetails[${index}].account_name`,
                                  setFieldValue,
                                  index,
                                  "account_name"
                                )}
                              />
                              {bankAccounts.length > 1 && (
                                <FaTimesCircle 
                                  style={{ color: colors.danger, marginLeft: 5, height: 40, marginTop: 30 }}
                                  onClick={() => removeBankAccount(bankAccount.id, setFieldValue)}
                                  size={26}
                                  className="pointer"
                                />
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </> 
                    :
                    <div className="app_input_group">
                      <InputField
                        labelTitle="Bank Name"
                        required={true}
                        placeholder="Select Bank Name"
                        name="name"
                        height={50}
                        containerWidth="30%"
                      />
                      <InputField
                        placeholder="Enter Bank Account Number"
                        name="account_number"
                        height={50}
                        type="number"
                        labelTitle="Bank Account Number"
                        required={true}
                        containerWidth="30%"
                      />
                      <InputField
                        labelTitle="Bank Account Name"
                        required={true}
                        placeholder="Select Bank Account Name"
                        name="account_name"
                        height={50}
                        containerWidth="30%"
                        isDefaultError={false}
                      />
                    </div>
                  }
                  
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <ButtonIcon
                      height={45}
                      marginTop={5}
                      color="#ffffff"
                      backgroundColor="#633ccd"
                      width={300}
                      borderColor="#633ccd"
                      buttonText={
                        bankAccountId ? "Update Account(s)" : "Add Account(s)"
                      }
                      type="submit"
                    />
                  </div>
                </Form>
              )}
              </Formik>
            </div>
          </div>
        </main>
        {isLoading && <FullPageLoader visible={isLoading} />}
        <Toast ref={toastTR} position="bottom-left" />
      </PaymentWrapper>
    </>
  );
};

export default AddUpdateBankAccount;
